import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'recent', label: 'Последние эфиры', icon: 'Clock' },
    { id: 'popular', label: 'Популярное', icon: 'TrendingUp' },
    { id: 'playlists', label: 'Плейлисты', icon: 'ListMusic' },
    { id: 'about', label: 'О канале', icon: 'Info' }
  ];

  return (
    <div className="content-tabs bg-background border-b border-border sticky top-16 z-50">
      <div className="tabs-container max-w-7xl mx-auto px-6">
        <div className="flex gap-1 overflow-x-auto scrollbar-hide">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => onTabChange(tab?.id)}
              className={`tab-button flex items-center gap-2 px-4 py-3 font-heading font-medium text-sm whitespace-nowrap transition-all duration-200 border-b-2 ${
                activeTab === tab?.id
                  ? 'text-primary border-primary' :'text-muted-foreground border-transparent hover:text-foreground hover:border-muted'
              }`}
              aria-current={activeTab === tab?.id ? 'page' : undefined}
            >
              <Icon 
                name={tab?.icon} 
                size={18} 
                color={activeTab === tab?.id ? 'var(--color-primary)' : 'currentColor'}
              />
              <span>{tab?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentTabs;